import { render, staticRenderFns } from "./projectTemplate.vue?vue&type=template&id=164d793e&scoped=true&"
import script from "./projectTemplate.vue?vue&type=script&lang=ts&"
export * from "./projectTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./projectTemplate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./projectTemplate.vue?vue&type=style&index=1&id=164d793e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164d793e",
  null
  
)

export default component.exports